/**
 * Formate la fecha resultante de un Date a formato dd/mm/YYYY
 * @param value
 * @returns {Promise<string>}
 */
export const dateToFormatUi = async (value) => {
    let d = new Date(value),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [day, month, year].join('/');
}

/**
 * Formate la fecha resultante de un Date a formato YYYY-mm-dd
 * @param value
 * @returns {string}
 */
export const dateToFormatDateServer = async (value) => {
    let d = new Date(value),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('-');
}

/**
 * Retornar un objeto como un query string
 * @param objectData
 * @returns {string}
 */
export const queryObjectToString = (objectData) => {
    // Obtener los keys
    let keys = Object.keys(objectData);
    // Obtener la ultima clave del array
    let lastKey = keys[keys.length - 1]
    // Acumulador o texto que se formara dinamicamente.
    let queryString = "";
    for (let namaKey of keys) {
        queryString += `${namaKey}=${objectData[namaKey]}`
        if (namaKey !== lastKey) {
            queryString += '&'
        }
    }
    return queryString
}

/**
 * Normaliza URLs de creativos: si apuntan al bucket S3 antiguo,
 * reemplaza el prefijo por el dominio CloudFront nuevo manteniendo
 * el path/nombre del recurso.
 *
 * @param {string | null | undefined} url
 * @returns {string | null | undefined}
 */
export const normalizeAdCreativeUrl = (url) => {
    if (!url || typeof url !== 'string') return url;

    const oldPrefix = 'https://by-scaling-clic-spy-anuncios.s3.us-east-2.amazonaws.com/';
    const newPrefix = 'https://d1y59uwrqmncmn.cloudfront.net/';

    return url.startsWith(oldPrefix) ? `${newPrefix}${url.slice(oldPrefix.length)}` : url;
}